<template>
  <LoadingContainer 
      :isLoading="loading" 
      :hasError="error"
      :hasNoResults="flightDetails === null || (flightDetails.outboundFlightNumber === null && flightDetails.inboundFlightNumber === null && !editMode)"
      errorMessage="Flight details could not be retrieved."
      noResultsMessage="No flight details available."
      color="alt-1"
  >
    <div class="row" v-if="flightDetails">
      <div class="col-md-12 content-list mb-2">
        <b>Outbound Flight:</b>
        <span v-if="!editModeValue">{{ flightDetails.outboundFlightNumber }}</span>
        <span>
          <input
            v-if="editModeValue"
            id="OutboundFlight"
            v-model="flightDetailsEdit.outboundFlightNumber"
            class="form-control"
          >
        </span>
      </div>

      <div class="col-md-12 content-list mb-2">
        <b>Inbound Flight:</b>
        <span v-if="!editModeValue">{{ flightDetails.inboundFlightNumber }}</span>
        <span>
          <input
            v-if="editModeValue"
            id="InboundFlight"
            v-model="flightDetailsEdit.inboundFlightNumber"
            class="form-control"
          >
        </span>
      </div>
    </div>

    <button
      v-if="editModeValue && flightDetails"
      class="btn btn-secondary mt-3"
      @click="editModeValue = !editModeValue"
    >
      Cancel <i class="icon--cross" />
    </button>
    <button
      v-if="editModeValue"
      class="btn btn-primary mt-3"
      @click="saveFlight"
    >
      Save <i class="icon--floppy-disk" />
    </button>
  </LoadingContainer>
</template>

<script>
import { mapState } from 'vuex'
import LoadingContainer from '../../layout/LoadingContainer';

export default {
    name: 'Flight',
    components: {
      LoadingContainer
    },
    props: ['editMode'],
    data () {
        return {
          loading: true,
          error: false,
          flightDetailsEdit: null
        }
    },
    computed: {
        editModeValue: {
            get: function () {
                return this.editMode
            },
            set: function (newValue) {
                this.$emit('update:editMode', newValue)
            }
        },
        ...mapState({
            flightDetails: state => state.booking.flightDetails
        })
    },
    async created () {
      this.loading = true;
      try {
        await this.$store.dispatch('getFlightDetails', this.$route.params.bookingId)
        this.flightDetailsEdit = Object.assign({}, this.$store.state.booking.flightDetails)
      } catch {
        this.error = true;
      }
      this.loading = false;
    },
    methods: {
        async saveFlight () {
            const result = await this.$store.dispatch('updateFlight', [this.$store.state.booking.bookingDetail.id, this.flightDetailsEdit])
            if (result.status === 200 || result.status === 201) {
                this.$toasted.success('Flight details saved')
                this.editModeValue = false
                this.$store.dispatch('getFlightDetails', this.$route.params.bookingId)
                this.$store.dispatch('getAudit', this.$route.params.bookingId)
            } else {
                this.$toasted.error(`Not Saved. Error: ${result.data}`)
            }
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
